var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDisbuesalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.7778 0H3.22222C1.45 0 0 1.45 0 3.22222V25.7778C0 27.55 1.45 29 3.22222 29H25.7778C27.55 29 29 27.55 29 25.7778V3.22222C29 1.45 27.55 0 25.7778 0ZM25.7778 25.7778H3.22222V3.22222H25.7778V25.7778ZM6.44444 11.2778H9.66667V22.5556H6.44444V11.2778ZM12.8889 6.44444H16.1111V22.5556H12.8889V6.44444ZM19.3333 16.1111H22.5556V22.5556H19.3333V16.1111Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisbuesalIcon);
export default __webpack_public_path__ + "static/media/DisbuesalIcon.06a16a1f016da3a101be191ae98b8670.svg";
export { ForwardRef as ReactComponent };